import React from "react";
import Draggable from 'react-draggable';
import { connect } from "react-redux";
import TwitchPlayer from "./TwitchPlayer";
import { closePlayer, setChannel } from "../../actions/playerActions";
import classNames from "classnames";
import closeIcon from "icons/close.svg";
import Icon from "../Icon/Icon";

class TwitchPlayerStandalone extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      render: true
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.channel !== this.props.channel) {
      //  грязный хак. Заставляем TwitchPlayer обновить плеер при смене канала.
      this.setState({ render: false }, () => {
        this.setState({ render: true });
      });
    }
  }

  render() {
    const { channel, title, closePlayer, route } = this.props;
    if (!channel) return null;
    if (route.includes("esports")) return null;

    return this.state.render && (
      <Draggable>
        <div className={ classNames("twitch-player-standalone") }>
          <div className="twitch-player-standalone__header">
            <span className="twitch-player-standalone__title"> { title }</span>
            <div className="twitch-player-standalone__buttons">
              <Icon glyph={ closeIcon } onClick={ closePlayer } className="twitch-player-standalone__close"/>
            </div>
          </div>
          <TwitchPlayer channel={ channel }/>
        </div>
      </Draggable>
    );
  }
}

export default connect(state => {
  return {
    channel: state.player.channel,
    title: state.player.title,
    route: state.router.location.pathname
  };
}, {
  closePlayer, setChannel
})(TwitchPlayerStandalone);


// WEBPACK FOOTER //
// ./app/components/TwitchPlayer/TwitchPlayerStandalone.jsx